import React, { useState, useEffect, useContext } from "react";
import BannerSection from "../inc/BannerSection";
import Banner from "../images/banner.jpg";

import Image from "react-bootstrap/Image";
import ApiService from "../../utility/services/ApiService";
import { AuthContext } from "../../utility/services/AuthContext";
import Functions from "../../utility/services/Functions";
import ImageConfig from "../../utility/configs/imageConfig";
import { useParams } from "react-router-dom";
import ConstConfig from "../../utility/configs/constConfig";

import ReactLoader from "react-js-loader";
import Button from "react-bootstrap/Button";
import StarRatings from "react-star-ratings";
import UserAvatar from "../common/UserAvatar";

const RatingreView = () => {
  // LOGICAL VARIABLES

  const therapist_id = useParams().id;

  const { get_therapist_reviews_list } = ApiService();
  const { setLoading } = useContext(AuthContext);
  const { consoleService, getStars, formet_date, isLastPage } = Functions();

  const [loadmoreLoading, setLoadmoreLoading] = useState(false);
  const [reviewListPageNo, setReviewListPageNo] = useState("1");

  // DATA VARIABLES

  const [ratingList, setRatingList] = useState([]);
  const [totalDocs, setTotalDocs] = useState("");

  // USE EFFECT

  useEffect(() => {
    fetch_initial_details();
  }, []);

  const fetch_initial_details = async () => {
    setLoading(true);

    try {
      const res = await get_therapist_reviews_list(therapist_id, 1);

      if (res.status === 1) {
        setRatingList(res.data?.reviews ? [...res.data.reviews] : []);
        setTotalDocs(res.data?.total?.[0]?.count || 0);
        setLoading(false);
      }
    } catch (err) {
      setLoading(false);
      consoleService("error in fetch_initial_details api =", err);
    }
  };
  const loadmore_reviews = async () => {
    if (!loadmoreLoading) {
      setLoadmoreLoading(true);
      const pageNo = Number(reviewListPageNo) + 1;
      try {
        const res = await get_therapist_reviews_list(therapist_id, pageNo);
        if (res.status === 1) {
          setRatingList([...ratingList, ...res.data.reviews]);
          setReviewListPageNo(pageNo);
          setTotalDocs(res.data.total[0].count);
          setLoadmoreLoading(false);
        } else {
          consoleService("Error in loadmore requests api", res);
        }
      } catch (err) {
        setLoadmoreLoading(false);
        consoleService("Error in loadmore requests api", err);
      }
    }
  };

  return (
    <>
      <BannerSection
        banner={Banner}
        name={"Home"}
        title={"Reviews and Ratings"}
      />

      <section className="py-5 specbox">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              {ratingList.map((item, index) => {
                return (
                  <React.Fragment key={index}>
                    <article className="article_detail_wrapss">
                      <div className="article_comments_thumb">
                        <UserAvatar
                          profileImage={item.profile_img}
                          firstName={item.first_name || item.name}
                          lastName={item.last_name}
                          size="md"
                          className="rounded-circle"
                          alt={`${item.name} profile`}
                        />
                      </div>
                      <div className="comment-details" style={{ flexGrow: 1 }}>
                        <div className="comment-meta">
                          <div className="comment-left-meta">
                            <div className="d-flex align-items-center justify-content-between">
                              <h4 className="author-name">{item.name}</h4>
                              <div className="comment-reply">
                                <div className="star-rating">
                                  <StarRatings
                                    rating={parseFloat(
                                      Number(item.rating).toFixed(1)
                                    )}
                                    starRatedColor="#FF674F"
                                    numberOfStars={5}
                                    name="rating"
                                    starDimension="20px"
                                    starSpacing={0}
                                  />
                                </div>
                              </div>
                            </div>
                            <div className="comment-date">
                              {formet_date(item.created_at)}
                            </div>
                          </div>
                        </div>
                        <div className="comment-text">
                          <p>{item.reviews}</p>
                        </div>
                      </div>
                    </article>
                    <hr />
                  </React.Fragment>
                );
              })}
              {loadmoreLoading && (
                <ReactLoader type="ping-cube" bgColor={"#4FF2E2"} size={50} />
              )}

              {!loadmoreLoading &&
                !isLastPage(reviewListPageNo, totalDocs, 10) && (
                  <div className="text-center mt-3">
                    <Button
                      className="btn btnNew btn-primary"
                      onClick={() => {
                        loadmore_reviews();
                      }}
                    >
                      Next
                    </Button>
                  </div>
                )}
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default RatingreView;
